export interface TourV2TrendingDestination {
  destinationName: string;
  imageId: string;
  placeId: string;
}

export enum TourV2TrendingDestinationImageId {
  AFRICA = 'tours-destinations-africa',
  AUSTRALIA = 'tours-destinations-australia',
  EGYPT = 'tours-destinations-egypt',
  INDIA = 'tours-destinations-india',
  JAPAN = 'tours-destinations-japan',
  SPAIN = 'tours-destinations-spain',
  SRILANKA = 'tours-destinations-srilanka',
  TURKEY = 'tours-destinations-turkey',
  VIETNAM = 'tours-destinations-vietnam'
}

const locationToImage: TourV2TrendingDestination[] = [
  { destinationName: 'Africa', imageId: TourV2TrendingDestinationImageId.AFRICA, placeId: 'le_b02e6098244d867ef9e033afaf097d81' },
  { destinationName: 'Australia', imageId: TourV2TrendingDestinationImageId.AUSTRALIA, placeId: 'le_d3d9446802a44259755d38e6d163e820' },
  { destinationName: 'Vietnam', imageId: TourV2TrendingDestinationImageId.VIETNAM, placeId: 'le_a597e50502f5ff68e3e25b9114205d4a' },
  { destinationName: 'India', imageId: TourV2TrendingDestinationImageId.INDIA, placeId: 'le_f033ab37c30201f73f142449d037028d' },
  { destinationName: 'Japan', imageId: TourV2TrendingDestinationImageId.JAPAN, placeId: 'le_7647966b7343c29048673252e490f736' },
  { destinationName: 'Spain', imageId: TourV2TrendingDestinationImageId.SPAIN, placeId: 'le_7e7757b1e12abcb736ab9a754ffb617a' },
  { destinationName: 'Sri Lanka', imageId: TourV2TrendingDestinationImageId.SRILANKA, placeId: 'le_5878a7ab84fb43402106c575658472fa' },
  { destinationName: 'Turkey', imageId: TourV2TrendingDestinationImageId.TURKEY, placeId: 'le_cedebb6e872f539bef8c3f919874e9d7' },
  { destinationName: 'Egypt', imageId: TourV2TrendingDestinationImageId.EGYPT, placeId: 'le_9a1158154dfa42caddbd0694a4e9bdc8' },
]

export function getTourV2TrendingDestinations(): TourV2TrendingDestination[] {
  return locationToImage
}
